<template>
  <div :key="forceRerender">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
    >
      <el-menu-item
        id="task_selector"
        index="tasks"
        v-if="instanceId"
        @click.native="
          $route.name !== 'tasks' &&
            $router.push(`/servers/${instanceId}/tasks`)
        "
      >
        <i class="el-icon-tickets" />
        <span slot="title">Tasks</span>
      </el-menu-item>
      <el-menu-item
        index="packages"
        v-if="instanceId"
        @click.native="
          $route.name !== 'packages' &&
            $router.push(`/servers/${instanceId}/packages`)
        "
      >
        <i class="el-icon-document-copy" />
        <span slot="title">Packages</span>
      </el-menu-item>
      <el-submenu index="0" v-if="instanceId">
        <template slot="title">
          <i class="el-icon-location" />
          <span slot="title">{{ envName }}</span>
        </template>
        <el-menu-item
          v-for="(server, index) in servers"
          :key="server.serverName"
          @click="login(server)"
          :class="{ selected: server.serverName === currentServer }"
          :index="`1-${index}`"
        >
          <span slot="title"
            ><i class="el-icon-menu" />{{ server.serverName }}</span
          >
        </el-menu-item>
      </el-submenu>
      <el-menu-item
        index="environments"
        class="link"
        @click.native="
          $route.name !== 'environments' && $router.push('/environments')
        "
        v-if="isUserLoggedIn"
      >
        <span slot="title">Environments</span>
        <i class="el-icon-s-platform" />
      </el-menu-item>
      <el-menu-item
        index="administration"
        @click.native="
          $route.name !== 'administration' && $router.push('/administration')
        "
        v-if="isUserLoggedIn && userRole === 'Administrator'"
      >
        <i class="el-icon-user" />
        <span slot="title">Administration</span>
      </el-menu-item>
      <el-menu-item
        index="agents"
        @click.native="$route.name !== 'agents' && $router.push('/agents')"
        v-if="isUserLoggedIn && userRole === 'Administrator'"
      >
        <i class="el-icon-connection" />
        <span slot="title">Agents</span>
      </el-menu-item>
      <el-menu-item
        @click="logoutRDM"
        index
        v-if="isUserLoggedIn"
        class="logout"
      >
        <i class="el-icon-switch-button" />
        <span slot="title">Log Out</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import EventBus from "../services/EventBus";
import { mapState } from "vuex";
import ServerService from "../services/ServerService";
import AuthenticationService from "../services/AuthenticationService";

export default {
  name: "Menu",
  data() {
    return {
      isCollapse: true,
      servers: [],
      activeIndex: this.$route.name,
      forceRerender: 0,
    };
  },
  computed: {
    ...mapState([
      "envName",
      "environmentId",
      "instanceId",
      "userRole",
      "isUserLoggedIn",
      "currentServer",
      "envType",
    ]),
  },
  watch: {
    instanceId(value) {
      if (value) this.showServers();
    },
    $route(value) {
      this.activeIndex = value.name;
    },
  },
  methods: {
    /**
     * Logs the user into the specified PA server
     * @function
     */
    async login(server) {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        await this.logoutPA();
        this.$router.push({ name: "servers", params: { server } });
      } catch (err) {
        this.$message({
          type: "warning",
          message: err.response ? err.response.data.error : err,
          duration: 7000,
          showClose: true,
        });
      } finally {
        loading.close();
      }
    },
    /**
     * Displays the list of PA servers available at the specified admin host
     * @function
     */
    async showServers() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        const response = await ServerService.show({
          environmentId: this.environmentId,
        });
        if (this.userRole === "Administrator") {
          this.servers = response.data.servers;
        } else {
          this.servers = response.data.servers.filter(
            (server) => server.username
          );
        }
      } catch (err) {
        this.$message({
          type: "warning",
          message: err.response ? err.response.data.error : err,
          duration: 7000,
          showClose: true,
        });
      } finally {
        loading.close();
      }
    },
    /**
     * Logs the user out of the app
     * @function
     */
    async logoutRDM() {
      if (confirm("Are you sure you want to log out of DataMaestro?")) {
        const loading = this.$loading({
          lock: true,
          //text: "Working",
          background: "rgba(0, 0, 0, 0.3)",
        });
        try {
          await this.logoutPA();
          await AuthenticationService.userLogout();
          this.$store.dispatch("resetEnvironment");
          this.$store.dispatch("logoutRDM");
          this.$router.push({ name: "login" });
        } catch (err) {
          this.$message({
            type: "warning",
            message: err.response ? err.response.data.error : err,
            duration: 7000,
            showClose: true,
          });
        } finally {
          loading.close();
        }
      } else {
        this.forceRerender += 1;
      }
    },
    /**
     * Logs the user out of the PA server
     * @function
     */
    async logoutPA() {
      try {
        if (this.instanceId) {
          await AuthenticationService.logout({
            instanceId: this.instanceId,
          });
          this.$store.dispatch("logoutPA");
        }
      } catch (err) {
        this.$message({
          type: "warning",
          message: err.response ? err.response.data.error : err,
          duration: 7000,
          showClose: true,
        });
      }
    },
  },
  mounted() {
    EventBus.$on("toggleMenu", () => {
      this.isCollapse = !this.isCollapse;
    });

    if (this.environmentId) this.showServers();
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
}
.el-menu-vertical-demo {
  height: 90vh;
}
.link {
  text-decoration: none;
}
.selected {
  text-decoration: underline;
}
</style>
